<template>
  <ConnectingMessage v-if="!common" />
  <template v-else>
    <SelectOption v-if="state.label === 'select'" :data="state.data" />
    <BuyOne v-if="state.label === 'buy-one'" :data="state.data" />
    <BuyMany v-if="state.label === 'buy-many'" />
    <BuyGroup v-if="state.label === 'buy-group'" />
    <EditGamepass v-if="state.label === 'edit-gamepass'" :data="state.data" />
    <OrderConfirmation
      v-if="state.label === 'order-confirm'"
      :data="state.data"
    />
    <PreOrderMessage v-if="state.label === 'preorder'" :data="state.data" />
    <PayMessage v-if="state.label === 'pay'" :data="state.data" />
    <SuccessMessage v-if="state.label === 'success'" :data="state.data" />
    <FindGamepass v-if="state.label === 'find-gamepass'" :data="state.data" />
    <CreateGamepass
      v-if="state.label === 'create-gamepass'"
      :data="state.data"
    />
  </template>
</template>

<script>
import SelectOption from "./routes/SelectOption.vue";
import BuyOne from "./routes/BuyOne.vue";
import BuyMany from "./routes/BuyList.vue";
import BuyGroup from "./routes/BuyGroup.vue";
import EditGamepass from "./routes/EditGamepass.vue";
import OrderConfirmation from "./routes/OrderConfirmation.vue";
import PreOrderMessage from "./routes/PreOrderMessage.vue";
import PayMessage from "./routes/PayMessage.vue";
import SuccessMessage from "./routes/SuccessMessage.vue";
import FindGamepass from "./routes/FindGamepass.vue";
import CreateGamepass from "./routes/CreateGamepass.vue";

import ConnectingMessage from "./components/ConnectingMessage.vue";

import { UserServiceClient } from "@/protos/user_grpc_web_pb.js";
import {
  GetCommonRequest,
  GetPromoRequest,
  GetGamepassInfoRequest,
  CreateOrderRequest,
  CreateGroupOrderRequest,
} from "@/protos/user_pb.js";
import config from "@/config.js";

import { useToast } from "vue-toastification";
import Utils from "@/utils.js";

export default {
  name: "App",
  components: {
    ConnectingMessage,
    SelectOption,
    BuyOne,
    BuyMany,
    BuyGroup,
    EditGamepass,
    OrderConfirmation,
    PreOrderMessage,
    PayMessage,
    SuccessMessage,
    FindGamepass,
    CreateGamepass,
  },

  data() {
    return {
      common: null,
      experimental: (new URLSearchParams()).get("experimental") !== undefined,

      state: {
        label: "select",
        data: null,
      },
    };
  },

  methods: {
    setState(newState) {
      this.state = newState;
    },

    restart() {
      this.setState({ label: "select" });
    },

    startBuildingOrder({
      method,
      gamepassesIds,
      group,
      nickname,
      amount,
      dupe = null,
      email,
      ignoreCheck = false,
      promo = null,
      bonus = 0,
    }) {
      console.log("startBuildingOrder", method);
      const dot = {
        method,
        gamepassesIds,
        group,
        nickname,
        amount,
        dupe,
        email,
        ignoreCheck,
        promo,
      };
      if (promo && bonus === 0) {
        const req = new GetPromoRequest();
        req.setCode(promo);
        req.setAmount(amount);

        return this.client.getPromo(req, {}, (err, data) => {
          if (err) {
            this.toast.error("Промокод не действителен.");
            return;
          }
          const bonus = data.getBonus();
          if (bonus !== 0) this.toast.success(`Сумма бонусов: ${bonus} R$`);
          const addBonus =
            ((gamepassesIds && gamepassesIds.length) || group) === 1
              ? bonus
              : 0;
          return this.startBuildingOrderDo({
            bonus,
            ...dot,
            amount: dot.amount + addBonus,
          });
        });
      } else return this.startBuildingOrderDo(dot);
    },

    startBuildingOrderDo({
      method,
      gamepassesIds,
      group,
      nickname,
      amount,
      dupe = null,
      email,
      ignoreCheck = false,
      promo = null,
      bonus = 0,
    }) {
      console.log("startBuildingOrderDo", method);
      if (amount - bonus < this.common.minAmount) {
        return this.toast.error(
          `Минимальная сумма покупки: ${this.common.minAmount} R$`,
        );
      }

      if (group) {
        if (amount > 5000)
          return this.toast.error(
            `Слишком большая покупка, максимум: ${5000}.`,
          );
        // if group
        if (this.common.available < amount) {
          return this.setState({
            label: "preorder",
            data: {
              method,
              group,
              amount,
              nickname,
              email,
              sellerName: nickname,
              promo,
              bonus,
            },
          });
        } else {
          return this.setState({
            label: "order-confirm",
            data: {
              method,
              group,
              amount,
              nickname,
              email,
              sellerName: nickname,
              promo,
              bonus,
            },
          });
        }

        return;
      }

      const re = Utils.takeCommision(5000);
      if (gamepassesIds.length == 1 && amount > re && dupe == null) {
        const { div, times } = Utils.splitNumber(amount, re);
        dupe = times;
        amount = div;
      }

      if ((email && !Utils.validateEmail(email)) || email.length > 64) {
        return this.toast.error("Неправильный формат email");
      }

      if (!gamepassesIds) return; // if gamepasses

      let r = new GetGamepassInfoRequest();
      r.setIdsList(gamepassesIds);

      if (gamepassesIds.length > 1) {
        if (this.common.available < amount) {
          return this.setState({
            label: "preorder",
            data: { method, gamepassesIds, amount, email, dupe, promo, bonus },
          });
        } else {
          return this.setState({
            label: "order-confirm",
            data: { method, gamepassesIds, amount, email, dupe, promo, bonus },
          });
        }
      }

      this.client.getGamepassInfo(r, {}, (err, resp) => {
        if (err) return this.toast.error(`Ошибка ${err}`);

        let gamepasses = resp.getGamepassesList();

        const gp = gamepasses[0];
        const price = gp.getPrice();
        const sellerName = gp.getSellerName();
        const name = gp.getName();

        if (!Utils.closeEnough(Utils.recommision(amount), price)) {
          this.$root.toast.warning("Цена не совпала.");
          if (gamepasses.length === 1) {
            return this.setState({
              label: "edit-gamepass",
              data: {
                method,
                id: gamepassesIds[0],
                universe: gamepasses[0].getUniverse(),
                dupe,
                amount,
                email,
                promo,
                bonus,
              },
            });
          }
        }
        if (this.common.available < amount) {
          // duplicate gamepasses
          return this.setState({
            label: "preorder",
            data: {
              method,
              gamepassesIds,
              amount,
              name,
              email,
              dupe,
              sellerName,
              promo,
              bonus,
            },
          });
        } else {
          return this.setState({
            label: "order-confirm",
            data: {
              method,
              gamepassesIds,
              amount,
              name,
              email,
              dupe,
              sellerName,
              promo,
              bonus,
            },
          });
        }
      });
    },
    order({
      method = "lava",
      gamepassesIds,
      group,
      nickname,
      amount,
      dupe = null,
      promo,
      bonus,
    }) {
      console.log("order", method);
      if (dupe !== null && gamepassesIds.length === 1) {
        gamepassesIds = new Array(dupe).fill(gamepassesIds[0]);
        amount *= dupe;
      }
      const handleOrderCreationResponse = async (err, resp) => {
        if (err) {
          return this.toast.error(`Ошибка ${err}`);
        }

        const id = resp.getId();
        const url = resp.getUrl();

        this.setState({ label: "pay", data: { id, url } });
      };

      if (group) {
        const order = new CreateGroupOrderRequest();
        order.setNickname(nickname);
        order.setGroupId(group.id);
        order.setAmount(amount);
        order.setMethod(method);

        if (promo) {
          order.setPromo(promo);
        }

        return this.client.createGroupOrder(
          order,
          null,
          handleOrderCreationResponse,
        );
      }

      if (!gamepassesIds) return;
      const order = new CreateOrderRequest();
      order.setGamepassesList(gamepassesIds);
      order.setAmount(amount);
      order.setMethod(method);

      if (promo) {
        order.setPromo(promo);
      }

      this.client.createOrder(order, null, handleOrderCreationResponse);
    },
  },
  setup() {
    return { toast: useToast() };
  },

  mounted() {
    const client = new UserServiceClient(config.ENVOY_GRPC_POINT, null, null);

    client.getCommon(new GetCommonRequest(), null, (err, resp) => {
      if (err) {
        throw err;
      }

      this.$root.common = {
        rate: parseFloat(resp.getRate().toPrecision(3)),
        groupRate: parseFloat(resp.getGroupRate().toPrecision(3)),
        available: resp.getAvailable(),
        minAmount: resp.getMinAmount(),
        sold: resp.getSold(),
      };

      this.$root.client = client;
    });
  },
};
</script>

<style lang="scss">
@mixin font($font-family, $font-file) {
  @font-face {
    font-family: $font-family;
    src: url($font-file + ".ttf") format("truetype");
    font-weight: normal;
    font-style: normal;
  }
}

@include font("Inter", "./assets/fonts/Inter/Inter-Regular");
@include font("Inter Thin", "./assets/fonts/Inter/Inter-Thin");
@include font("Inter Medium", "./assets/fonts/Inter/Inter-Medium");
@include font("Inter Light", "./assets/fonts/Inter/Inter-Light");

* {
  color: #ffffff;
  font-family: "Inter";
  box-sizing: border-box;
}

a {
  text-decoration: none;
  padding: 5px;
  background: rgba(0, 0, 255, 0.1);
  transition: 0.5s linear;
  &:hover {
    background: rgba(0, 0, 255, 0.3);
  }

  &:active {
    transition: 0.05s linear;
    background: rgba(0, 255, 255, 0.5);
    color: #00ffff;
  }
}

.spacetop {
  margin-top: 15px;
}

.all-center {
  align-items: center;
  text-align: center;
  justify-content: center;
}

.form {
  gap: 25px;
  display: flex;
  flex-direction: column;
}

.thead {
  font-size: 36px;
}

.sub {
  font-size: 24px;
  color: rgba(255, 255, 255, 0.6);
}

.fs24 {
  font-size: 24px;
}

.fs20 {
  font-size: 20px;
}

.fs30 {
  font-size: 30px;
}

.t-thin {
  font-family: "Inter Thin";
}

.t-medium {
  font-family: "Inter Medium";
}

.t-light {
  font-family: "Inter Light";
}

.t-center {
  text-align: center;
}

.t-green {
  color: #00ff29;
}

.t-red {
  color: #ff0000;
}

.t-white {
  color: white;
}

.t-gray {
  color: rgba(255, 255, 255, 0.7);
}

.bg-darker {
  background: rgba(0, 0, 0, 0.2) !important;
}

.sector {
  padding: 20px;
}

textarea,
input[type="text"] {
  resize: none;
  outline: none;
  border: none;
  background: none;
  font-size: 24px;
  padding: 10px 25px 10px 25px;
}

button {
  outline: none;
  padding: 15px 100px 15px 100px;
  text-align: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  border: none;
  transition: 0.3s linear;

  &.green {
    background: rgba(0, 191, 54, 0.4);

    &:hover {
      background: rgba(0, 255, 0, 0.5);
    }
  }

  &.red {
    background: rgba(176, 16, 16, 0.4);

    &:hover {
      background: rgba(255, 0, 0, 0.5);
    }
  }

  &:hover {
    background: rgba(0, 0, 0, 0.1);
    transition: 0.1s linear;
    cursor: pointer;
  }

  &:active {
    background: rgba(0, 0, 0, 0);
  }
}

body {
  padding: 0px;
  margin: 0px;
  width: 100%;
  height: 100vh;
}
#app {
  padding: 15px;
  width: 100%;
  height: 100vh;
  background: #1a1e24;
  font-style: normal;
  font-weight: 400;
  color: #ffffff;
  overflow: auto;
  > * {
    margin: 0 auto;
    max-width: 1022px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    flex-direction: column;
    align-items: center;
  }
}

.df {
  display: flex;
  gap: 10px;
}

.fc {
  flex-direction: column;
}

.fr {
  flex-direction: row;
}

.wa {
  width: 100%;
}

.ha {
  height: 100%;
}

.amount {
  color: red;
  padding: 5px;
  background: rgba(255, 0, 0, 0.1);
  transition: 0.5s linear;
  &:hover {
    background: rgba(255, 0, 0, 0.3);
  }

  &:active {
    transition: 0.05s linear;
    background: rgba(255, 255, 0, 0.5);
    color: #ffff00;
  }
}
</style>
